/**
 * 埋点 配置 
 */
export const SYSTEM_NAME = 'UAPP';
import { terminal } from '@/util/browser.js';

const eventOption = () => {
    return {
        // title: document.title,
        // url: location.href,
        // os: 10086,
        // timestamp: new Date().getTime(),
        // terminal: terminal().appVersion
    };
};
/**
 * 埋点事件集合
 * ps: 新增加的事件key都是首字母大写驼峰命名，老的埋点key保持原样不再做更改
 * https://confluence.nioint.com/pages/viewpage.action?pageId=304244710
 */
export const TRACKER_EVENTS = [
    {
        action: 'enter', // 用户进入留资页面
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'enter',
                ...eventOption()
            };
        }
    },
    {
        action: 'return', // 用户点击返回
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'return',
                ...eventOption()
            };
        }
    },
    {
        action: 'agree_privacy', // 用户进入留资页面
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'agree_privacy',
                ...eventOption()
            };
        }
    },
    {
        action: 'car_model', // 用户选择了车型
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'car_model',
                ...eventOption()
            };
        }
    },
    {
        action: 'city', // 用户选择了用车城市
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'city',
                ...eventOption()
            };
        }
    },
    {
        action: 'td_location', // 用户选择了试驾点
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'td_location',
                ...eventOption()
            };
        }
    },
    {
        action: 'change_phone', // 用户点击更换
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'change_phone',
                ...eventOption()
            };
        }
    },
    {
        action: 'bind_phone', // 用户输入了手机号，点击 “获取验证码” 按钮
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'bind_phone',
                ...eventOption()
            };
        }
    },
    {
        action: 'code', // 用户选择了区号
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'code',
                ...eventOption()
            };
        }
    },
    {
        action: 'invite_code', // 用户填写邀请码
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'invite_code',
                ...eventOption()
            };
        }
    },
    {
        action: 'manual_td', // 用户点击手动预约
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'manual_td',
                ...eventOption()
            };
        }
    },
    {
        action: 'allow_get_phone', // 用户允许获取手机号
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'allow_get_phone',
                ...eventOption()
            };
        }
    },
    {
        action: 'td_success', // 提交成功
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'td_success',
                ...eventOption()
            };
        }
    },
    {
        action: 'help_td', // 切换帮好友预约
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'help_td',
                ...eventOption()
            };
        }
    },
    {
        action: 'help_td_success', // 帮好友预约提交
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'help_td_success',
                ...eventOption()
            };
        }
    },
    {
        action: 'check_tdorder', // 点击跳转试驾单按钮
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'check_tdorder',
                ...eventOption()
            };
        }
    },
    {
        action: 'check_tdorder', // 点击跳转试驾单按钮
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'check_tdorder',
                ...eventOption()
            };
        }
    },
    {
        action: 'cancel_td', // 用户取消试驾单
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'cancel_td',
                ...eventOption()
            };
        }
    },
    {
        action: 'accept_invite', // 好友接受邀请
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'accept_invite',
                ...eventOption()
            };
        }
    },
    {
        action: 'guide_click', // 点击成功页按钮
        key: 'RetentionFlow',
        custom: () => {
            return {
                step_name: 'guide_click',
                ...eventOption()
            };
        }
    },
    {
        action: 'fellow_expo', // Fellow曝光
        key: 'ContactFellowExpo',
        custom: () => {
            return {
                ...eventOption()
            };
        }
    },
    {
        action: 'contact_fellow', // 联系fellow
        key: 'ContactFellow',
        custom: () => {
            return {
                ...eventOption()
            };
        }
    }
];



// WEBPACK FOOTER //
// ./src/config/report.js